import {
  Truck, Sparkles, Trash2, KeyRound, Tv,
  ShieldCheck, Clock3, Award,
  MessageSquareQuote, CalendarCheck, CheckCircle2,
  Phone, Mail, MapPin, Star, Facebook, Instagram, Music2,
  Wrench, Hammer, Home, Settings, Wand2, Package,
} from "lucide-react";

// Icons available for picking in the admin
export const ICONS = {
  Truck, Sparkles, Trash2, KeyRound, Tv,
  ShieldCheck, Clock3, Award,
  MessageSquareQuote, CalendarCheck, CheckCircle2,
  Phone, Mail, MapPin, Star,
  Facebook, Instagram, Music2,
  Wrench, Hammer, Home, Settings, Wand2, Package,
};

export const ICON_NAMES = Object.keys(ICONS);

export function Icon({ name, className, ...rest }) {
  const Cmp = ICONS[name] || Truck;
  return <Cmp className={className} {...rest} />;
}
